// redux/store.ts: sets up the store and configures redux-persist.
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist"; //persistReducer and persistStore for state persistence.
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { combineReducers } from "redux";

import authReducer from "../features/store/authSlice";
import appDataReducer from "../features/store/appDataSlice";
import purchaseDataReducer from "../features/store/dataPurchaseSlice";
import transactionReducer from "../features/store/transactionSlice";
import purchaseAirtimeReducer from "../features/store/airtimePurchaseSlice";
import localeReducer from "../features/store/localeSlice";
import purchaseElectricityReducer from "../features/store/electricityPurchaseSlice";
import transferPaymentReducer from "../features/store/transferPaymentSlice";
import userReducer from "../features/store/userSlice";
import currencyReducer from "../features/store/currencySlice";
import purchaseCableReducer from "../features/store/cablePurchaseSlice";
import purchaseGiftcardReducer from "../features/store/giftcardPurchaseSlice";
import purchaseTopupReducer from "../features/store/topupPurchaseSlice";
import purchaseGamecardReducer from "../features/store/gamecardPurchaseSlice";
import purchaseDGCoinReducer from "../features/store/dgcoinPurchaseSlice";
import searchReducer from "../features/store/searchSlice";
import providerFaqReducer from "../features/store/providerFaqSlice";
import supportReducer from "../features/store/supportSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  appData: appDataReducer,
  users: userReducer,
  purchaseData: purchaseDataReducer,
  transactions: transactionReducer,
  purchaseAirtime: purchaseAirtimeReducer,
  purchaseElectricity: purchaseAirtimeReducer,
  locale: localeReducer,
  transferPayment: transferPaymentReducer,
  currencies: currencyReducer,
  purchaseCable: purchaseCableReducer,
  purchaseGiftcard: purchaseGiftcardReducer,
  purchaseTopup: purchaseTopupReducer,
  purchaseGamecard: purchaseGamecardReducer,
  purchaseDGCoin: purchaseDGCoinReducer,
  search: searchReducer,
  support: supportReducer,
  providerFaqs: providerFaqReducer,
});

const persistConfig = {
  key: "root", // Key for the persisted state.
  storage, // Storage engine (localStorage for web).
  whitelist: ["auth", "appData", "locale"], // Only persist the auth slice
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store); //It ensures that the parts of the store wrapped with the persistReducer (in this case, persistedReducer) are persisted to the specified storage (e.g., localStorage).

// get back to these
export type RootState = ReturnType<typeof store.getState>; //RootState is the type for your entire store's state.
export type AppDispatch = typeof store.dispatch; //AppDispatch is the type for your store's dispatch function, ensuring type-safe action dispatching.
